import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class InstrumentTypeSearchCriteria extends ValueObject {

    public searchCriteria: string = "";
}